export const EnvelopeIcon = () => (
  <svg width="18px" height="13px" viewBox="0 0 18 13" version="1.1">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Navigation-/-Desktop"
        transform="translate(-243.000000, -57.000000)"
        fill="#808080"
        fillRule="nonzero"
      >
        <g id="Navigation" transform="translate(-29.000000, -1.000000)">
          <g id="Newsletters" transform="translate(271.000000, 55.000000)">
            <g
              id="email-action-unread"
              transform="translate(0.931507, 3.000000)"
            >
              <path
                d="M0.907278329,1.08437399 C0.911445956,1.07909425 0.915694576,1.07391493 0.920021061,1.06883644 C1.22348852,0.703337092 1.68131201,0.470588235 2.19349315,0.470588235 L15.6934932,0.470588235 C16.2056726,0.470588235 16.6634947,0.703335541 16.9669622,1.06883279 C16.9712908,1.07391367 16.9755415,1.07909548 16.9797111,1.0843778 C17.2099656,1.36862063 17.3479049,1.7307027 17.3479049,2.125 L17.3479049,11.125 C17.3479049,12.038701 16.6071942,12.7794118 15.6934932,12.7794118 L2.19349315,12.7794118 C1.27979211,12.7794118 0.539081386,12.038701 0.539081386,11.125 L0.539081386,2.125 C0.539081386,1.73070094 0.677021911,1.36861739 0.907278329,1.08437399 Z M1.59790492,2.29204062 L1.59790492,11.125 C1.59790492,11.453929 1.86456419,11.7205882 2.19349315,11.7205882 L15.6934932,11.7205882 C16.0224221,11.7205882 16.2890814,11.453929 16.2890814,11.125 L16.2890814,2.29204068 L10.7790429,6.53011548 C9.69691538,7.3625692 8.19007114,7.36256922 7.1079751,6.53013985 L1.59790492,2.29204062 Z M2.34309689,1.52941176 L7.75354293,5.69088455 C8.45506534,6.23054817 9.4319211,6.23054816 10.133475,5.69086021 L15.5438895,1.52941176 L2.34309689,1.52941176 Z"
                id="Combined-Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const EventIcon = () => (
  <svg width="15px" height="15px" viewBox="0 0 15 15" version="1.1">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRrule="evenodd"
    >
      <g
        id="Navigation-/-Desktop"
        transform="translate(-946.000000, -56.000000)"
        fill="#AEAEAE"
      >
        <g id="Navigation" transform="translate(-29.000000, -1.000000)">
          <g id="Stacked-Group-2" transform="translate(975.000000, 54.750000)">
            <g id="Events">
              <g id="Calendar" transform="translate(0.000000, 3.000000)">
                <path
                  d="M3.55566408,10.7303233 C3.46621197,10.6717929 3.42838809,10.5597016 3.46400328,10.4586539 L3.65754008,9.9194565 C3.68073137,9.85402394 3.73235959,9.80239572 3.79751606,9.77948052 C3.86212036,9.75601315 3.93500726,9.76346749 3.99436591,9.79880659 C4.1735462,9.90592825 4.59347413,10.0881455 5.03466074,10.0881455 C5.36734526,10.0881455 5.61941245,10.0028347 5.7850645,9.83442178 C5.91675787,9.70024363 5.99047303,9.50863943 5.9868839,9.30930481 C5.97777304,8.52963585 5.05150203,8.49015545 4.86541957,8.49015545 L4.4711677,8.49015545 C4.34333954,8.49015545 4.23980702,8.38662292 4.23980702,8.25907085 L4.23980702,7.72760388 C4.23980702,7.59977572 4.34333954,7.49624319 4.4711677,7.49624319 L4.86541957,7.49624319 C5.24200188,7.49624319 5.80135361,7.32203246 5.80135361,6.84191762 C5.80135361,6.48245268 5.55756902,6.28422241 5.11500198,6.28422241 C4.75470879,6.28422241 4.39855689,6.44766576 4.20336357,6.58736565 C4.14483318,6.62905474 4.07001367,6.64147865 4.00099199,6.62049605 C3.93279856,6.59978955 3.87758122,6.54816133 3.85218124,6.48079616 L3.65892052,5.96534222 C3.6219249,5.86705534 3.65588356,5.75634456 3.74119437,5.69560548 C4.02887675,5.49019694 4.59761543,5.25027757 5.251941,5.25027757 C6.44629224,5.25027757 6.98079616,5.99267481 6.98079616,6.72899814 C6.98079616,7.22484993 6.75440504,7.64643438 6.3449684,7.93660154 C6.86069843,8.21047958 7.18233948,8.7201357 7.18233948,9.32117654 C7.18233948,10.1891932 6.51282914,11.1223664 5.04294334,11.1223664 C4.38640908,11.1223664 3.83175082,10.9114362 3.55566408,10.7303233 Z M8.02329969,6.77841767 L7.88663675,6.23894418 C7.86040851,6.13568774 7.90789543,6.02829 8.00148884,5.97804221 L9.14476402,5.366234 C9.17844661,5.34801227 9.2159944,5.33890141 9.25381829,5.33890141 L9.85789607,5.33890141 C9.98572423,5.33890141 10.0892568,5.44243394 10.0892568,5.5702621 L10.0892568,10.802658 C10.0892568,10.9302101 9.98572423,11.0337426 9.85789607,11.0337426 L9.17347705,11.0337426 C9.04564889,11.0337426 8.94211636,10.929934 8.94211636,10.802658 L8.94211636,6.60945258 L8.35764073,6.92501973 C8.29469296,6.95870231 8.22014954,6.96229144 8.15444089,6.93357842 C8.08928442,6.90431322 8.04096924,6.84743935 8.02329969,6.77841767 Z M12.6019222,0.134942465 C13.3862846,0.134942465 14.024045,0.772978919 14.024045,1.55706526 L14.024045,12.4550371 C14.024045,13.2388474 13.3860085,13.8771599 12.6019222,13.8771599 L1.72824595,13.8771599 C0.943883526,13.8771599 0.306123158,13.2391235 0.306123158,12.4550371 L0.306123158,1.55678917 C0.306123158,0.772702832 0.944159613,0.134942465 1.72824595,0.134942465 L12.6019222,0.134942465 Z M10.1386763,1.16198513 C9.8344287,1.16198513 9.58788324,1.40853059 9.58788324,1.71277818 C9.58788324,2.01702577 9.83470479,2.26329514 10.1386763,2.26329514 C10.4426478,2.26329514 10.6891932,2.01674968 10.6891932,1.71277818 C10.6891932,1.40880668 10.4429239,1.16198513 10.1386763,1.16198513 Z M4.22103312,1.15756775 C3.91706162,1.15756775 3.67024007,1.40438929 3.67024007,1.70836079 C3.67024007,2.01233229 3.91706162,2.25887775 4.22103312,2.25887775 C4.52500462,2.25887775 4.77155008,2.01260838 4.77155008,1.70836079 C4.77155008,1.40438929 4.52528071,1.15756775 4.22103312,1.15756775 Z M13.0986022,12.4553132 L13.0986022,3.09983796 L1.23184199,3.09983796 L1.23184199,12.4553132 C1.23184199,12.7289152 1.45436791,12.9519932 1.72824595,12.9519932 L12.6021983,12.9519932 C12.8760763,12.9519932 13.0986022,12.7289152 13.0986022,12.4553132 Z"
                  id="Combined-Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const ListIcon = () => (
  <svg width="12px" height="11px" viewBox="0 0 12 11" version="1.1">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Navigation-/-Desktop"
        transform="translate(-1205.000000, -58.000000)"
        fill="#AEAEAE"
        fillRule="nonzero"
      >
        <g id="Navigation" transform="translate(-29.000000, -1.000000)">
          <g id="Stacked-Group-2" transform="translate(975.000000, 54.750000)">
            <g id="Lists" transform="translate(259.000000, 0.000000)">
              <path
                d="M3.555556,10.597223 L11.555556,10.597223 L11.555556,8.819445 L3.555556,8.819445 L3.555556,10.597223 Z M3.555556,4.375 L3.555556,6.152778 L11.555556,6.152778 L11.555556,4.375 L3.555556,4.375 Z M3.555556,15.041668 L11.555556,15.041668 L11.555556,13.26389 L3.555556,13.26389 L3.555556,15.041668 Z M0,10.597223 L1.777778,10.597223 L1.777778,8.819445 L0,8.819445 L0,10.597223 Z M0,4.375 L0,6.152778 L1.777778,6.152778 L1.777778,4.375 L0,4.375 Z M0,15.041668 L1.777778,15.041668 L1.777778,13.26389 L0,13.26389 L0,15.041668 Z"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const DotsIcon = () => (
  <svg width="6px" height="7px" viewBox="0 0 6 7" version="1.1">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Navigation-/-Desktop"
        transform="translate(-382.000000, -188.000000)"
        fill="#917E52"
      >
        <g id="Navigation" transform="translate(-29.000000, -1.000000)">
          <g id="Community" transform="translate(29.000000, 179.000000)">
            <g id="Community-Menu" transform="translate(382.000000, 6.000000)">
              <g id="Find-Your-Community:-2">
                <path
                  d="M0,4.5 L1.95907956,4.5 L1.95907956,6.58083089 L0,6.58083089 L0,4.5 Z M0,8.41916911 L1.95907956,8.41916911 L1.95907956,10.5 L0,10.5 L0,8.41916911 Z M4.04092044,4.5 L6,4.5 L6,6.58083089 L4.04092044,6.58083089 L4.04092044,4.5 Z M4.04092044,8.41916911 L6,8.41916911 L6,10.5 L4.04092044,10.5 L4.04092044,8.41916911 Z"
                  id="Combined-Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
